<template>
    <div v-if="activity && activity.length" class="tw-flex tw-flex-col tw-gap-3 tw-bg-slate-50 tw-p-4">
        <article v-for="activityEvent in activity" :key="activityEvent.id" class="tw-flex tw-items-start tw-gap-3">
            <User v-if="activityEvent.user" :user="activityEvent.user" hide-name size="small" class="tw-mt-1" />
            <div
                v-else
                class="tw-mt-1 tw-flex tw-h-8 tw-w-8 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-eventwise tw-text-white tw-shadow-sm"
                title="Eventwise"
            >
                <i class="mdi mdi-robot-outline tw-text-lg"></i>
            </div>

            <div
                class="tw-min-w-0 tw-flex-1 tw-overflow-hidden tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white tw-shadow-sm"
            >
                <div
                    class="tw-flex tw-items-center tw-justify-between tw-gap-3 tw-border-b tw-border-slate-100 tw-px-3 tw-py-2"
                >
                    <span class="tw-truncate tw-text-sm tw-font-semibold tw-text-slate-700">
                        {{ activityEvent.user?.name || activityEvent.user?.email || 'Eventwise' }}
                    </span>
                    <time
                        class="tw-shrink-0 tw-text-xs tw-text-slate-400"
                        :title="DateTime.fromISO(activityEvent.occurred_at).toLocaleString(DateTime.DATETIME_FULL)"
                    >
                        {{ DateTime.fromISO(activityEvent.occurred_at).toLocaleString(DateTime.DATE_MED) }}
                    </time>
                </div>
                <div class="tw-flex tw-flex-col tw-gap-2 tw-px-3 tw-py-2.5">
                    <p
                        v-if="activityEvent.description"
                        class="tw-m-0 tw-text-sm tw-leading-5 tw-text-slate-600"
                        v-html="activityEvent.description"
                    ></p>
                    <p
                        v-if="activityEvent.comment"
                        class="tw-m-0 tw-rounded-md tw-border-l-2 tw-border-slate-200 tw-bg-slate-50 tw-p-2 tw-text-sm tw-italic tw-leading-5 tw-text-slate-500"
                        v-html="activityEvent.comment"
                    ></p>
                </div>
            </div>
        </article>
    </div>
    <p v-else class="tw-p-8 tw-text-center tw-text-sm tw-text-slate-400">There is no activity to show here just yet</p>
</template>
<script lang="ts" setup>
import User from '@/js/components/widgets/User.vue';
import type { Activity as ActivityType } from '@/js/types/activity.ts';
import { DateTime } from 'luxon';

defineProps<{
    activity: ActivityType[];
}>();
</script>
